import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    // Bảng kê chi tiết thu tiền
    data: {},
    total: 0,
    searchCriteria: {},
    // Lịch sử bảng kê chi tiết thu tiền
    dataHistory: {},
    totalHistory: 0,
    searchCriteriaHistory: {},
    // Thu tiền bảng kê chi tiết thu tiền
    dataDepositRefer: {},
};
const slice = createSlice({
    name: 'detailStatementOfReceipt',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
                total: action.payload?.total || 0,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
                total: 0,
            };
        },

        save_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        save_list_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        save_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        get_history: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                searchCriteriaHistory: action?.payload,
            };
        },
        save_history: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                dataHistory: action.payload,
            };
        },
        get_deposit_refer: (state) => {
            return {
                ...state,
                isRequesting: false,
                dataDepositRefer: {},
            };
        },
        save_deposit_refer: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                dataDepositRefer: action.payload,
            };
        },
        request_export_success: (state) => {
            const { export: exportData, ...restSearchCriteria } = state.searchCriteria;
            return {
                ...state,
                isRequesting: false,
                searchCriteria: {
                    ...restSearchCriteria,
                },
            };
        },
        reset_state: () => {
            return initialState;
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
